<template>
  <div class="trbo-a-landing-page-container">
    <div
      v-if="imageUrl"
      class="trbo-a-header-image"
      :style="{ 'background-image': 'url(' + imageUrl + ')' }" />
    <div class="trbo-a-panel">
      <div class="trbo-a-panel-title">{{ title }}</div>
      <!-- eslint-disable vue/no-v-html -->
      <div class="trbo-a-panel-description" v-html="sanitizedDescription" />
      <!-- eslint-enable -->
      <button class="trbo-a-panel-button" @click="onClickStart()">
        <svg class="trbo-a-panel-button-arrow-icon" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 16H27" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M18 7L27 16L18 25" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
        </svg>
        {{ buttonTitle }}
      </button>
    </div>
  </div>
</template>

<script>
// @flow

import { mapGetters, mapActions } from 'vuex'

import { logger } from '../../../common'
import { linkify, sanitizedMarkup } from '../../../common/utils'

import { dispatchChatchampEvent, WIZARD_EVENTS } from '../../../main/eventTracking'

export default {
  computed: {
    ...mapGetters(['landingPage']),
    imageUrl () {
      return this.landingPage.imageUrl
    },
    title () {
      return this.landingPage.title || 'Welcome to our product recommender'
    },
    sanitizedDescription () {
      let description = this.landingPage.description || 'Find your product with only a couple of clicks'
      description = description.replace(/\n/g, '\\n')
      return linkify(sanitizedMarkup(description))
    },
    buttonTitle () {
      return this.landingPage.buttonTitle || 'Let\'s go'
    },
    eventPayload () {
      return {
        customerId: this.$store.state.customerId,
        subscriberId: this.$store.state.subscriberId,
        wizardId: this.$store.state.wizard.id,
        landingPageId: this.$store.getters.landingPage.id
      }
    }
  },
  mounted () {
    logger.info('Wizard has been loaded.')
    dispatchChatchampEvent(WIZARD_EVENTS.Loaded, this.eventPayload)
  },
  methods: {
    ...mapActions(['startWizard']),
    onClickStart () {
      dispatchChatchampEvent(WIZARD_EVENTS.Started, this.eventPayload)
      this.startWizard()
    }
  }
}
</script>

<style scoped src="./landing-page.scss" />
